import BaseModel from './base';
import HallExposition from './exhibition-hall-exposition';

import Exhibition from './exhibition';

export default class ExhibitionTag extends BaseModel {
  constructor(item, url) {
    super(item, url);

    this.exhibitions = (item.exhibitions || [])
      .map((exhibition) => new Exhibition(exhibition, 'exhibitions'));

    this.expositions = (item.expositions || [])
      .map((exposition) => new HallExposition(exposition, 'exhibition-expositions'));
  }
}
